import React, { useEffect, createElement, Component } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { HowItWorks } from './components/HowItWorks';
import { Features } from './components/Features';
import { IngredientDemo } from './components/IngredientDemo';
import { DownloadCTA } from './components/DownloadCTA';
import { Footer } from './components/Footer';
import { BlogPage } from './components/BlogPage';
import { BlogPost } from './components/BlogPost';
import { AboutPage } from './components/AboutPage';
import { HowToGuide } from './components/HowToGuide';
import { PrivacyPolicy } from './components/PrivacyPolicy';
import { TermsOfService } from './components/TermsOfService';
import { ContactSupport } from './components/ContactSupport';
import { EditorialPolicy } from './components/EditorialPolicy';
import { Testimonials } from './components/Testimonials';
import { WhatItDoes } from './components/WhatItDoes';
import { WhyIngredientsMatter } from './components/WhyIngredientsMatter';
import { IngredientCategories } from './components/IngredientCategories';
import { AppScreenshots } from './components/AppScreenshots';
import { FAQ } from './components/FAQ';
import { LatestBlogPosts } from './components/LatestBlogPosts';
// Component to handle scrolling to hash links when navigating from another page
function ScrollToHash() {
  const {
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const element = document.getElementById(hash.replace('#', ''));
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }, [hash]);
  return null;
}
function HomePage() {
  useEffect(() => {
    document.title = 'IntelliEats — Scan Ingredients, Eat Smarter';
    const meta = document.createElement('meta');
    meta.name = 'google-adsense-account';
    meta.content = 'ca-pub-3041826185319356';
    document.head.appendChild(meta);
    let desc = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!desc) {
      desc = document.createElement('meta');
      desc.name = 'description';
      document.head.appendChild(desc);
    }
    desc.content = 'IntelliEats is a free ingredient scanner app that instantly detects unhealthy ingredients in packaged food. Scan any label with your camera to see which ingredients to avoid, limit, or enjoy — and make smarter, healthier choices in seconds.';
    return () => {
      document.head.removeChild(meta);
    };
  }, []);
  return <main data-id="element-0" data-mp="3lkhge7qgxhp9">
      <HeroSection data-id="element-1" data-mp="3lkr2vlcb16q7" />
      <WhatItDoes data-id="element-2" data-mp="3ljg2lvi2ih3u" />
      <HowItWorks data-id="element-3" data-mp="3liwjwcklfoor" />
      <WhyIngredientsMatter data-id="element-4" data-mp="3liedin47vu34" />
      <Features data-id="element-5" data-mp="2xun2dmuexn3f" />
      <IngredientCategories data-id="element-6" data-mp="2xu3kg64riype" />
      <IngredientDemo data-id="element-7" data-mp="2xtby7lx22dbs" />
      <AppScreenshots data-id="element-8" data-mp="2xssjee2pc51z" />
      <Testimonials data-id="element-9" data-mp="2sw207hvlotcc" />
      <FAQ data-id="element-10" data-mp="2swljp30wfpsh" />
      <LatestBlogPosts data-id="element-11" data-mp="2sv0pjeihy8v5" />
      <DownloadCTA data-id="element-12" data-mp="2svjyi5q65mx1" />
    </main>;
}
export function App() {
  useEffect(() => {
    let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/vxdue6obzwd6hjhd7fonaj/c2dc3655-bf08-4072-907a-0e44a0f2759c/intellieats_icon.webp";
  }, []);
  return <BrowserRouter data-id="element-13" data-mp="1r4sg0db86yu7">
      <ScrollToHash data-id="element-14" data-mp="1r268gdoc4jbz" />
      <div className="min-h-screen bg-white" data-id="element-15" data-mp="1w3c0sae324kz">
        <Navbar data-id="element-16" data-mp="1w211amro7izo" />
        <Routes data-id="element-17" data-mp="1w2kig19hy3cn">
          <Route path="/" element={<HomePage data-id="element-19" data-mp="1i3uj0ez7frl4" />} data-id="element-18" data-mp="1w0zoodv0aofu" />
          <Route path="/blog" element={<BlogPage data-id="element-21" data-mp="1i3b313t47d9q" />} data-id="element-20" data-mp="1i2j7fszipfjg" />
          <Route path="/blog/:slug" element={<BlogPost data-id="element-23" data-mp="1m4egxkrlqz8b" />} data-id="element-22" data-mp="1m562e2rhjgkv" />
          <Route path="/about" element={<AboutPage data-id="element-25" data-mp="1m70o3jakzcq0" />} data-id="element-24" data-mp="1m3l6o9tfprlf" />
          <Route path="/guides/how-to-scan-pantry" element={<HowToGuide data-id="element-27" data-mp="6n4a2o3eclnt" />} data-id="element-26" data-mp="6nw6u28qcpfo" />
          <Route path="/privacy" element={<PrivacyPolicy data-id="element-29" data-mp="aq9c6pjkelbx" />} data-id="element-28" data-mp="6qs1nhpa6xzw" />
          <Route path="/terms" element={<TermsOfService data-id="element-31" data-mp="ano7lsrvtrah" />} data-id="element-30" data-mp="arkfko93lr2i" />
          <Route path="/contact" element={<ContactSupport data-id="element-33" data-mp="qxx9z3omiby4" />} data-id="element-32" data-mp="qxnnvr6p8oxp" />
          <Route path="/editorial-policy" element={<EditorialPolicy data-id="element-35" data-mp="m65jet5gw67z" />} data-id="element-34" data-mp="qyypbkco9kln" />
        </Routes>
        <Footer data-id="element-36" data-mp="m4cat8banbxc" />
      </div>
    </BrowserRouter>;
}